import { useContext } from 'react'
import { useRouter } from 'next/router'
import { SharedContext } from '@/context/SharedContext'

export const useRouterHook = () => {
  const { setSkeletonloader, setHistoryStack } = useContext(SharedContext)
  const router = useRouter()

  const navigateToPagesInAdvertiser = async ({ pathName, as, query = {}, isHome = false }: any) => {
    setSkeletonloader?.({ isVisible: true, pathName })
    setHistoryStack((prv: any) => ({ ...prv, isForword: true }))
    await router.push(
      {
        pathname: `/${pathName}`,
        query
      },
      isHome ? 'hire' : `hire/${(as || pathName).toLowerCase()}`
    )
    setSkeletonloader?.({ isVisible: false, pathName })
  }

  const replaceThePageInAdvertiser = async ({
    pathName,
    as,
    query = {},
    isHome = false,
    isHistoryPop = true
  }: any) => {
    if (isHistoryPop)
      setHistoryStack((prv: any) => {
        prv?.data?.pop()
        return { ...prv }
      })
    setSkeletonloader?.({ isVisible: true, pathName })
    await router.replace(
      {
        pathname: `/${pathName}`,
        query
      },
      isHome ? 'hire' : `hire/${(as || pathName).toLowerCase()}`
    )
    setSkeletonloader?.({ isVisible: false, pathName })
  }

  const navigateToPagesInSeeker = async ({
    pathName,
    as,
    query = {},
    isHome = false,
    shallow = false
  }: any) => {
    setHistoryStack((prv: any) => ({ ...prv, isForword: true }))
    setSkeletonloader?.({ isVisible: true, pathName })
    await router.push(
      {
        pathname: `/${pathName}`,
        query
      },
      isHome ? '/jobs' : `jobs/${(as || pathName).toLowerCase()}`,
      { shallow }
    )
    setSkeletonloader?.({ isVisible: false, pathName })
  }

  const replaceToPagesInSeeker = async ({
    pathName,
    as,
    query = {},
    isHome = false,
    shallow = false,
    isHistoryPop = true
  }: any) => {
    if (isHistoryPop)
      setHistoryStack((prv: any) => {
        prv?.data?.pop()
        return { ...prv }
      })
    setSkeletonloader?.({ isVisible: true, pathName })
    await router.replace(
      {
        pathname: `/${pathName}`,
        query
      },
      isHome ? '/jobs' : `jobs/${(as || pathName).toLowerCase()}`,
      { shallow }
    )
    setSkeletonloader?.({ isVisible: false, pathName: 'jobsFiltering' })
  }

  const routerBackNavigation = () => {
    router?.back()
  }
  return {
    navigateToPagesInAdvertiser,
    replaceThePageInAdvertiser,
    navigateToPagesInSeeker,
    replaceToPagesInSeeker,
    routerBackNavigation,
    router
  }
}
